import React from "react";
import { Badge } from "reactstrap";
import PropTypes from "prop-types";
import { MasterSidebar } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * LevelSidebar
 * Lista de níveis utilizando o componente padronizado MasterSidebar.
 * Suporta Drag and Drop para reordenação.
 */
const LevelSidebar = ({ levels, activeId, onSelect, onCreateNew, loading, onReorder }) => {

    // Renderização customizada de cada item da lista de níveis
    const renderLevelItem = (level, isActive) => (
        <div className="text-start w-100 overflow-hidden">
            <div className="d-flex align-items-center justify-content-between">
                <p className={`mb-0 fw-semibold text-truncate ${isActive ? 'text-primary' : 'text-dark'}`} style={{ fontSize: '13.5px' }}>
                    {level.name}
                </p>
                <div className="d-flex align-items-center gap-2 flex-shrink-0">
                    {level.value > 0 && (
                        <Badge color="info" className="font-size-10 px-2 opacity-75 rounded-1">
                            {level.value} pts
                        </Badge>
                    )}
                    {level.status === GLOBAL_STATUS.INACTIVE && (
                        <i className="mdi mdi-eye-off-outline text-muted" style={{ fontSize: '14px' }} title="Inativo"></i>
                    )}
                </div>
            </div>
            <span className="text-muted small text-truncate d-block mt-1" style={{ fontSize: '11px', opacity: 0.8 }}>
                Ordem: {level.order ?? 0}
            </span>
        </div>
    );

    return (
        <MasterSidebar
            title="Níveis"
            subtitle="Graduação e progressão"
            items={levels}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            loading={loading}
            searchPlaceholder="Buscar nível..."
            icon="mdi mdi-stairs"
            renderItem={renderLevelItem}
            onReorder={onReorder}
            loadingMessage="Carregando níveis..."
        />
    );
};

LevelSidebar.propTypes = {
    levels: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func,
    onCreateNew: PropTypes.func,
    loading: PropTypes.bool,
    onReorder: PropTypes.func
};

export default LevelSidebar;
